import script from "./AgentCapabilities.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentCapabilities.vue?vue&type=script&lang=ts&setup=true"

import "./AgentCapabilities.vue?vue&type=style&index=0&id=c992f4ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c992f4ba"]])

export default __exports__